import logger from '../logger';
import { globalStore } from '~/stores';

type UserDetails = {
  email?: string;
  firstName?: string;
  lastName?: string;
  workspaceDisplayName?: string;
  additionalQuery?: string;
};

export enum HubspotFormTypes {
  SIGNUP = 'signup',
  NEED_HELP = 'needHelp'
}

export function submitHubspotForm(
  userDetails: UserDetails,
  formType?: HubspotFormTypes
) {
  const callSdkToSubmit = () => {
    const formData = {
      firstName: userDetails.firstName || '',
      lastName: userDetails.lastName || '',
      email: userDetails.email || '',
      company: userDetails.workspaceDisplayName || '',
      book_demo_query: userDetails.additionalQuery || ''
    };
    if (globalStore.debugModeEnabled || import.meta.env.MODE === 'staging') {
      logger.info('Hubspot Form data:', formData);
    } else {
      window.skApi.hubspot?.[formType ?? HubspotFormTypes.SIGNUP]?.(
        formData,
        function (err) {
          logger.info(err, 'Failed to submit Hubspot signup form');
        },
        function (data) {
          logger.info(
            data,
            `Hubspot ${formType ?? HubspotFormTypes.SIGNUP} form submitted`
          );
        }
      );
    }
  };
  //check if the script is already present
  if (window.skApi?.hubspot?.signup) {
    callSdkToSubmit();
  } else {
    const skIntegrationJs =
      'https://cdn.scalekit.cloud/scalekit-website/scripts/sk-integrations-SZrQBxuQ.js';
    const skIntegrationScript = document.createElement('script');
    skIntegrationScript.setAttribute('src', skIntegrationJs);
    skIntegrationScript.onload = () => {
      callSdkToSubmit();
    };
    document.head.appendChild(skIntegrationScript);
  }
}
